var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.count),function(i){return _c('v-skeleton-loader',{key:i,attrs:{"width":_vm.width,"type":"list-item-avatar-two-line"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }